import { VariantType, useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type SnackbarOptions = {
  message: string;
  variant?: VariantType;
  vertical?: 'top' | 'bottom';
  horizontal?: 'left' | 'center' | 'right';
};

const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const sendNotification = ({ message, variant = 'default', vertical = 'top', horizontal = 'right' }: SnackbarOptions) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical,
        horizontal
      },
      action: (snackbarId) => (
        <IconButton size="small" aria-label="close" color="inherit" onClick={() => closeSnackbar(snackbarId)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )
    });
  };

  return [sendNotification] as const;
};
export default useNotification;
